import { useState, useEffect, useCallback } from 'react';
import apiService, { parseGetAllUsersResponse } from '../services/api';

interface User {
  userid: number;
  name: string;
  phoneNumber: string;
  hubid?: number;
}

const useSupportUsers = (roleId: number = 4) => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    setError(null);
    
    try {
      const payload = {
        name: null,
        roleid: roleId,
        hubid: null,
        userstatus: null,
        kycstatus: null,
        registrationdate: null,
        reporttype: "staff",
        pageNumber: 1,
        pageSize: 500,
      };

      const response = await apiService.getAllUsers(payload);
      const { items: responseData } = parseGetAllUsersResponse(response);
      
      // Transform the data to extract userid, name, and phoneNumber
      const userList = responseData
        .filter((user: any) => user.userid && user.name)
        .map((user: any) => ({
          userid: user.userid,
          name: user.name || user.fullname || "",
          hubid: user.hubid,
          phoneNumber: user.phoneNumber || user.phonenumber || user.mobile || user.phone || ""
        }));
      
      setUsers(userList);
    } catch (err: any) {
      console.error('Error fetching users:', err);
      setError(err.message || "Failed to fetch users");
      setUsers([]);
    } finally {
      setLoading(false);
    }
  }, [roleId]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return { users, loading, error, refetch: fetchUsers };
};

export default useSupportUsers;
